const api = window.OEPFELCHASPER_API ? window.OEPFELCHASPER_API.api : null;

export const OEPFELCHASPER_API_ORDERABLE_PRIVATE = api ? api.OEPFELCHASPER_API_ORDERABLE_PRIVATE : '';
export const OEPFELCHASPER_API_ORDERABLE_BUSINESS = api ? api.OEPFELCHASPER_API_ORDERABLE_BUSINESS : '';
export const OEPFELCHASPER_API_ORDERABLE = api ? api.OEPFELCHASPER_API_ORDERABLE : '';
export const OEPFELCHASPER_API_ORDER_PRIVATE = api ? api.OEPFELCHASPER_API_ORDER_PRIVATE : '';
export const OEPFELCHASPER_API_ORDER_BUSINESS = api ? api.OEPFELCHASPER_API_ORDER_BUSINESS : '';
export const OEPFELCHASPER_API_ORDER_TESTBASKET = api ? api.OEPFELCHASPER_API_ORDER_TESTBASKET : '';
export const OEPFELCHASPER_API_ORDER_COUPON = api ? api.OEPFELCHASPER_API_ORDER_COUPON : '';
export const OEPFELCHASPER_API_CREATE_QUOTE = api ? api.OEPFELCHASPER_API_CREATE_QUOTE : '';



// WEBPACK FOOTER //
// ./static/js/Order/store/api.js